module.exports = __webpack_public_path__ + "static/media/project-scope.d25b7df9.png";